/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_File_FallbackInputs */

const cs_ebr_file_fallback = /** @type {(inputs: Ebr_File_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemáte odkaz? Nahrajte XML soubor v CSV/obecném průvodci níže.`)
};

const en_ebr_file_fallback = /** @type {(inputs: Ebr_File_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No link? Upload an XML file in the generic wizard.`)
};

/**
* | output |
* | --- |
* | "No link? Upload an XML file in the generic wizard." |
*
* @param {Ebr_File_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_file_fallback = /** @type {((inputs?: Ebr_File_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_File_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_file_fallback(inputs)
	return cs_ebr_file_fallback(inputs)
});